import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    spendCardContainer: {
        height: '80px',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        gap: '20px',
        [theme.breakpoints.down(1920)]: {
            gap: '18px',
        },
        [theme.breakpoints.down(1600)]: {
            // height: '120px',
            gap: '16px',
        },
        [theme.breakpoints.down(1366)]: {
            // height: '110px',
            gap: '14px',
        },
    },
    spendCardItem: {
        // height: '133px',
        width: '312px',
        backgroundColor: '#FAFAFA',
        padding: '20px',
        boxSizing: 'border-box',
        display: 'flex',
        // flexDirection: 'column',
        gap: '16px',
        [theme.breakpoints.down(1920)]: {
            width: '290px',
            padding: '18px',
            gap: '14px',
        },
        [theme.breakpoints.down(1600)]: {
            // height: '120px',
            width: '260px',
            padding: '16px',
            gap: '12px',
        },
        [theme.breakpoints.down(1366)]: {
            // height: '110px',
            width: '240px',
            padding: '14px',
            gap: '12px',
        },
    },
    spendCardIcon: {
        width: '32px',
        height: '32px',
        [theme.breakpoints.down(1920)]: {
            width: '30px',
            height: '30px',
        },
        [theme.breakpoints.down(1600)]: {
            width: '28px',
            height: '28px',
        },
        [theme.breakpoints.down(1366)]: {
            width: '26px',
            height: '26px',
        },
    },
    spendCardContentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        boxSizing: 'border-box',
        gap: '8px',
        [theme.breakpoints.down(1920)]: {
            gap: '7px',
        },
        [theme.breakpoints.down(1600)]: {
            gap: '6px',
        },
        [theme.breakpoints.down(1366)]: {
            gap: '6px',
        },
    },
    spendCardLabel: {
        fontSize: '12px',
        fontWeight: 400,
        color: '#5F6071',
        fontStyle: 'normal',
        lineHeight: 'normal',
        [theme.breakpoints.down(1920)]: {
            fontSize: '11px',
        },
        [theme.breakpoints.down(1600)]: {
            fontSize: '11px',
        },
        [theme.breakpoints.down(1366)]: {
            fontSize: '10px',
        },
    },
    spendCardValue: {
        fontSize: '14px',
        fontWeight: 400,
        color: '#2B2C35',
        fontStyle: 'normal',
        lineHeight: 'normal',
        [theme.breakpoints.down(1920)]: {
            fontSize: '13px',
        },
        [theme.breakpoints.down(1600)]: {
            fontSize: '12px',
        },
        [theme.breakpoints.down(1366)]: {
            fontSize: '12px',
        },
    },
    spendCardLoader: {
        color: '#1976d2', // Blue color for Material-UI v4 primary blue
    },
}));

export default useStyles;

